<template>
	<div class="box">
		<div class="title">
			<p>合作船公司</p>
			<p>CONTRACT SHIPPING COMPANY</p>
		</div>
		<div class="cont clearfix">
			<a :href="item.baktwo" target="_blank" :title="item.baktwo" v-for="(item, index) in list" :key="index">
				<div>
					<img :src="item.showpath" alt="" />
					<img v-for="(items,indexs) in item.attas" :key="indexs" :src="items.path" alt="" />
				</div>
				<p>{{ item.name }}</p>
				<span>{{ item.content }}</span>
			</a>
			<!-- <div v-for="(item, index) in list" :key="index">
				<div>
					<img v-for="(items,indexs) in item.attas" :key="indexs" :src="items.path" alt="" />
				</div>
				<p>{{ item.name }}</p>
				<span>{{ item.content }}</span>
			</div> -->
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: [
					// {
					//   pic: "item1",
					//   en: "MSK",
					//   cn: "马士基",
					// },
					// {
					//   pic: "item2",
					//   en: "MSC",
					//   cn: "地中海",
					// },
					// {
					//   pic: "item3",
					//   en: "CMA-CGM",
					//   cn: "达飞轮船",
					// },
					// {
					//   pic: "item4",
					//   en: "EVERGREEN",
					//   cn: "长荣海运",
					// },
					// {
					//   pic: "item5",
					//   en: "HPL",
					//   cn: "赫伯罗特",
					// },
					// {
					//   pic: "item6",
					//   en: "ONE",
					//   cn: "海洋网联",
					// },
					// {
					//   pic: "item7",
					//   en: "YANGMING",
					//   cn: "阳明海运",
					// },
					// {
					//   pic: "item8",
					//   en: "WANHAI",
					//   cn: "万海航运",
					// },
					// {
					//   pic: "item9",
					//   en: "HMM",
					//   cn: "现代商船",
					// },
					// {
					//   pic: "item10",
					//   en: "OOCL",
					//   cn: "东方海外",
					// },
					// {
					//   pic: "item11",
					//   en: "APL",
					//   cn: "美国总统",
					// },
					// {
					//   pic: "item12",
					//   en: "HSD",
					//   cn: "汉堡南美",
					// },
					// {
					//   pic: "item13",
					//   en: "SAF",
					//   cn: "萨菲海运",
					// },
					// {
					//   pic: "item14",
					//   en: "SEALAND",
					//   cn: "(MCC）",
					// },
					// {
					//   pic: "item15",
					//   en: "ZIM",
					//   cn: "以星航运",
					// },
					// {
					//   pic: "item16",
					//   en: "HASCO",
					//   cn: "海华轮船",
					// },
					// {
					//   pic: "item17",
					//   en: "PIL",
					//   cn: "太平船务",
					// },
					// {
					//   pic: "item18",
					//   en: "SITC",
					//   cn: "山东海丰",
					// },
					// {
					//   pic: "item19",
					//   en: "SAMUDERA",
					//   cn: "萨姆达拉",
					// },
					// {
					//   pic: "item20",
					//   en: "NAMSUNG",
					//   cn: "南星海运",
					// },
					// {
					//   pic: "item21",
					//   en: "COSCOSHIPPING",
					//   cn: "中远海运",
					// },
					// {
					//   pic: "item22",
					//   en: "RCL",
					//   cn: "宏海箱运",
					// },
					// {
					//   pic: "item23",
					//   en: "JJ Shipping",
					//   cn: "锦江轮船",
					// },
					// {
					//   pic: "item24",
					//   en: "NDS",
					//   cn: "尼罗河航运",
					// },
				],
			};
		},
		methods: {
			getImgUrl(icon) {
				//展示图片
				return require(`@/assets/del/${icon}.png`);
			},
			getCompanyList() {
				this.$http.get("webpc/pcteamwork/list").then((res) => {
					this.list = res.data.detail;

				});
			},
		},
		created() {
			//获取合作船公司列表
			this.getCompanyList();
		},
	};
</script>

<style lang="scss" scoped>
	.box {
		width: 100%;
		height: 100%;
		background-image: url("../../assets/img/compBG.jpg");
		background-size: 100% 100%;
		background-position: 100% 100%;
		background-repeat: no-repeat;
		display: flex;
		flex-direction: column;
		align-items: center;

		.title {
			margin-top: 44px;
			font-size: 20px;
			color: #ffffff;
			text-align: center;
		}

		.cont {
			width: 954px;
			box-sizing: border-box;
			padding-bottom: 48px;
			margin-top: 30px;
			margin-bottom: 60px;

			a {
				display: block;
				width: 152px;
				height: 152px;
				margin-left: 6px;
				margin-bottom: 6px;
				background: #fff;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				color: #2e2e2e;
				font-size: 16px;
				border-radius: 3px;
				float: left;
				transition: all 0.2s;
				div {
					height: 40px;
					width: 100%;
					margin: 0;
					margin-bottom: 10px;
					margin-top: 14px;

					img {
						// width: 70%;
						// height: auto;
						display: block;
						max-width: 120px;
						max-height: 34px;
						margin: 0 auto 15px;
					}
				}

				p {
					font-weight: 600;
					margin-bottom: 3px;
				}
			}
			a:hover{
			  transform: scale(1.04);
			  transform-origin: center center;
			  box-shadow: 2px 2px 2px rgba(0,0,0,0.3);
			}
			div::nth-child(1) {
				margin: 0;
			}
		}
	}
</style>
